import React from "react";
import {Navbar,Footer} from '../dashboard';
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import * as Icon from 'react-bootstrap-icons';
import { format } from "date-fns";
import { assetCategory } from '../utils/datalist';


const AddEquipment=()=>{

    if(localStorage.getItem('branchID')===null){
        window.location.replace('/');
    }

    const [assetData,setAssetData]=useState([]);
    const [deptList,setDeptList]=useState([]);
    const [empData,setEmpData]=useState([]);
    const [filter, setFilter] = useState(empData);
    const [empSearch,setEmpSearch]=useState();

    useEffect(() => {
        setAssetData({...assetData,['branchID']:localStorage.getItem('branchID')});
        const getDeptData = async () => {
            const deptRes=await axios.get(configData.SERVER_URL+`/deptData/${localStorage.getItem('branchID')}`);
            setDeptList(deptRes.data);  
        };

        const getEmpData = async () => {
          const response=await axios.get(configData.SERVER_URL+`/empData/${localStorage.getItem('branchID')}`)
          setEmpData(await response.data);
          setFilter(await response.data);
        };

        getDeptData();
        getEmpData();
  
    }, []);

    const handleInput=(e)=>{
        const {name,value}=e.target; 
        setAssetData({...assetData,[name]:value});  
    }


    const handleSubmit=async(e)=>{
        e.preventDefault();       
        try {
            let res=await axios.post(configData.SERVER_URL+`/assetDataInsert`,assetData);
            if(res.status===200){
                alert(res.data.message);
            } 
        } catch (error) {
            console.error('System error:', error);
        }   
    }

    
    const filterEmployee=(e)=>{
    setEmpSearch(e.target.value);
    const updatedList = empData.filter((emp) => emp.empName.toLowerCase().includes(empSearch));
    setFilter(updatedList);
  }

    return(
            <>
            <div className='container' style={{marginTop:100}}>
            <Navbar/>
            <hr></hr>
            <div className="card well bg-info "> 
                <div className="card-header">ICT Equipment Entry</div>
                <div className="card-body" style={{backgroundColor: "lightgrey", padding: "20px", borderRadius: "10px"}}>
                
                    <div className="row well">       

                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                <label>Item Category</label>
                                <select className="form-select" id="assetCategory" name="assetCategory" value={assetData.assetCategory} onChange={(e)=>{handleInput(e)}}>
                                <option value=''>---</option>
                                {assetCategory.map(category => (
                                <option key={category.code} value={category.code}>{category.name}</option>
                                ))}
                                </select>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                            <label>Item Code</label>
                            <input type="text" className="form-control" name="assetCode" id="assetCode" value={assetData.assetCode} onChange={(e)=>{handleInput(e)}}></input>
                        </div>
    
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <label>Item Description</label>
                            <input type="text" className="form-control" name="description" id="description" value={assetData.description} onChange={(e)=>{handleInput(e)}} ></input>
                        </div>    
                          
                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                <label>User</label>
                                <input type="text" className="form-control" name="empSearch" id="empSearch" placeholder="Search by name" value={empSearch} onChange={(e)=>filterEmployee(e)}></input>
                                <select className="form-control" id="empID" name="empID" value={assetData.empID} onChange={(e)=>{handleInput(e)}} required>
                                <option value=''>---</option>
                                {filter.map(data => (
                                <option key={data.id} value={data.id}>{data.empCode} : {data.empName} : {data.deptName} </option>
                                ))}
                                </select>
                        </div>
       
                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                <label>Assign Department</label>
                                <select className="form-control" id="deptID" name="deptID" value={assetData.deptID} onChange={(e)=>{handleInput(e)}} required>
                                <option value=''>---</option>
                                {deptList.map(dept => (
                                <option key={dept.id} value={dept.id}>{dept.deptName}</option>
                                ))}
                                </select>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                <label>Purchase Date</label>
                                <input type="date" className="form-control" id="purchaseYear" name="purchaseYear" value={assetData.purchaseYear} onChange={(e)=>{handleInput(e)}}></input>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                            <label>Purchase Price</label>
                            <input type="number" className="form-control" name="price" id="price" value={assetData.price} onChange={(e)=>{handleInput(e)}} ></input>
                        </div> 

                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <br></br>
                        <button type="button" class="btn btn-info">
                        <span onClick={(e)=>{handleSubmit(e)}}>POST</span>              
                        </button>
                        </div>

                    </div>
                       
                    
                </div>
            </div>
            <Footer/>
            </div>
            
            </>
        )
}

export default AddEquipment;